(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-floral-inquiry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-floral-inquiry')) {
    customElements.define('custom-floral-inquiry', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const pieces = [...this.querySelectorAll('[data-floral-piece]')];
        if (!pieces.length) return;
        const validatePieces = () => {
          pieces[0].setCustomValidity(pieces.some(piece => piece.checked) ? '' : 'Please choose at least one floral piece.');
        };
        this.addEventListener('change', validatePieces, { signal: this.controller.signal });
        validatePieces();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
